<template>
  <div class="pa-2 text-center si-sta-facendo-asta-per" v-if="classic">
    <span>Si sta facendo asta per </span>
    <b
      ><span v-if="ruolo_da_chiamare == Constants.RUOLO_DA_CHIAMARE.QUALUNQUE"
        >QUALUNQUE RUOLO</span
      >
      <span v-else>{{
        Constants.RUOLI_NEW[ruolo_da_chiamare].plurale
      }}</span></b
    >
    <v-btn outlined depressed x-small rounded icon @click="promptImpostazioni">
      <v-icon x-small>edit</v-icon>
    </v-btn>
  </div>
</template>



<script>
import mixins from "../../js/mixins";
import Constants from "../../js/constants";
import db from "../../js/db";

export default {
  name: "si-sta-facendo-asta-per",
  components: {},
  mixins: [mixins],
  mounted() {
    console.log("--> SiStaFacendoAstaPer mounted.");
  },
  destroyed() {
    console.log("<-- SiStaFacendoAstaPer destroyed.");
  },
  methods: {
    promptImpostazioni() {
      db.emit("showImpostazioni", "#ruolo_da_chiamare");
    },
  },
  computed: {
    ruolo_da_chiamare() {
      return this.asta_settings.ruolo_da_chiamare;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../main.scss";
.si-sta-facendo-asta-per{
  background: var(--v-grey-lighten3);;
}
</style>
